module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_1_4.5aa71d87.png";